import type { IStepConfig } from '@cbhq/client-analytics';
import { IThresholdTier } from '@cbhq/client-analytics';

export type StepMark =
  | 'navigate_to_workspace_member_invite_modal'
  | 'loaded_workspace_member_invite_modal'
  | 'submit_workspace_member_invite'
  | 'workspace_member_invite_success'
  | 'submit_workspace_member_update'
  | 'workspace_member_update_success'
  | 'navigate_to_workspace_remove_member_modal'
  | 'loaded_workspace_remove_member_modal'
  | 'submit_workspace_member_removal'
  | 'workspace_member_removal_success';

export const userJourneySteps: Record<string, IStepConfig<StepMark>> = {
  load_workspace_member_invite_modal: {
    threshold: IThresholdTier.moderate,
    marks: ['navigate_to_workspace_member_invite_modal', 'loaded_workspace_member_invite_modal'],
  },
  submit_workspace_member_invite: {
    threshold: IThresholdTier.moderate,
    marks: ['submit_workspace_member_invite', 'workspace_member_invite_success'],
  },
  submit_workspace_member_update: {
    threshold: IThresholdTier.moderate,
    marks: ['submit_workspace_member_update', 'workspace_member_update_success'],
  },
  load_workspace_remove_member_modal: {
    threshold: IThresholdTier.moderate,
    marks: ['navigate_to_workspace_remove_member_modal', 'loaded_workspace_remove_member_modal'],
  },
  submit_workspace_member_removal: {
    threshold: IThresholdTier.moderate,
    marks: ['submit_workspace_member_removal', 'workspace_member_removal_success'],
  },
};
